import { createFileRoute, Link } from "@tanstack/react-router";
import { LoanCategoryPage } from "@/components/laneguide/LoanCategoryPage";

export const Route = createFileRoute("/privatlan/")({
  head: () => ({
    meta: [
      { title: "Privatlån – Jämför lån hos 40+ banker | Svensk Låneguide" },
      { name: "description", content: "Jämför privatlån från Sveriges 40+ ledande banker. Endast 1 UC och räntor från 4,50 %." },
      { property: "og:title", content: "Privatlån – Jämför lån hos 40+ banker" },
      { property: "og:description", content: "Jämför privatlån från Sveriges 40+ ledande banker." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => (
    <LoanCategoryPage
      page="privatlan"
      productLabel="Privatlån"
      headingBefore="Låna pengar med"
      underlined="snabba utbetalningar"
      headingAfter=""
      subtitle={
        <>
          Hitta rätt <Link to="/nyhet/$slug" params={{ slug: "vad-ar-privatlan" }} className="text-primary underline underline-offset-2">privatlån</Link> genom att jämföra räntor, villkor och lånebelopp från flera långivare. Använd vår topplista eller lånekalkylator för att hitta ett lån som passar dig. Vi visar bara långivare som står under Finansinspektionens tillsyn – lär dig vad ett privatlån kostar och vilka krav du behöver uppfylla.
        </>
      }
      featuredTitleTemplate={(m) => `Toppval för snabba utbetalningar i ${m}`}
    />
  ),
});
